import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ActivitySummary from './activity-summary';
import DefaultHeader from '../../../shared/default-header/components/default-header';
import Helpers from '../../../../common/helpers';
// import DashboardHelpers from '../helpers/dashboard-helpers';
import RenderIf from '../../../shared/render-if/components/render-if';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import PageHeader from '../../../shared/page-header/components/page-header';
import B2BDashboard from './b2b-dashboard';
import NotApprovedDashboard from './not-approved-dashboard';
import { getChartData, getSummary } from '../actions/dashboard-actions';
import { getCampaigns } from '../../campaigns/actions/campaigns-actions';
import { getSites } from '../../link-creator/actions/link-creator-actions';
import registerConstants from '../../register/constants/register-constants';

class Dashboard extends Component {
  componentDidMount() {
    const { getSummary, getCampaigns, campaigns, sites, getSites } = this.props;

    // getChartData();
    getSummary();

    if (!campaigns) {
      getCampaigns();
    }

    if (!sites) {
      getSites(true);
    }
  }

  render() {
    const { fetchingChartData, httpInProgress, profile, uiBlocked } = this.props;

    // const formattedChartData = DashboardHelpers.formatChartData(chartsData);

    return (
      <div className="dashboard-container">
        <RenderIf if={!uiBlocked}>
          <PageHeader title={'MENU.DASHBOARD'} />
        </RenderIf>
        <div className="row">
          <RenderIf if={fetchingChartData || httpInProgress}>
            <div className="col-md-12 p-a-30">
              <DefaultLoader />
            </div>
          </RenderIf>
        </div>
        <RenderIf if={profile}>
          <div className="row">
            <RenderIf if={profile && profile.user_type !== registerConstants.user_types.b2b}>
              <div className="row">
                <RenderIf if={uiBlocked}>
                  <NotApprovedDashboard />
                </RenderIf>
                <RenderIf if={!uiBlocked}>
                  <div>
                    {/* <div className="col-md-12">
                      <DefaultHeader title={'DASHBOARD.PERFORMANCE'} actionText={'DASHBOARD.VIEW_PAYMENTS'} actionCallback={() => Helpers.goToPage('/app/payments')} />
                    </div>
                    <RenderIf if={!fetchingChartData}>
                      <div className="col-md-12">
                        <PerformanceChart labels={formattedChartData.labels} data={formattedChartData.data} />
                      </div>
                    </RenderIf> */}
                    <div className="col-md-12 m-t-10">
                      <DefaultHeader title={'DASHBOARD.ACTIVITY_SUMMARY'} actionText={'DASHBOARD.VIEW_FULL_REPORTS'} actionCallback={() => Helpers.goToPage('/app/clients')} />
                    </div>
                    <ActivitySummary />
                  </div>
                </RenderIf>
              </div>
            </RenderIf>
            <RenderIf if={profile && profile.user_type === registerConstants.user_types.b2b}>
              <B2BDashboard />
            </RenderIf>
          </div>
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  chartsData: state.dashboardReducer.chartsData,
  fetchingChartData: state.dashboardReducer.fetchingChartData,
  campaigns: state.campaignsReducer.campaigns,
  sites: state.linkCreatorReducer.sites,
  profile: state.userProfileReducer.profile,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  uiBlocked: state.layoutReducer.uiBlocked,
});

const mapDispatchToProps = dispatch => ({
  getChartData: () => {
    dispatch(getChartData());
  },
  getSummary: () => {
    dispatch(getSummary());
  },
  getCampaigns: () => {
    dispatch(getCampaigns());
  },
  getSites: (active, pageCode) => {
    dispatch(getSites(active, pageCode));
  },
});

Dashboard.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/dashboard.js